import React from 'react';
import {change} from "redux-form";

import {store} from "../../main";
import {capitalizeFirstLetter} from "../../misc";
import {setSubscriptionId} from "../AddNewEntity/AddNewEntityActions";

export default class Subscription extends React.Component {

  getProgramTypePriority = type => {
    switch (type) {
      case 'free':
        return 0;
      case 'pay-per-lead':
      case 'kv-only':
      case 'bv-only':
      case 'kv-bv-only':
        return 1;
      case 'basics':
        return 2;
      case 'enterprise':
        return 3;
      default:
        return -1;
    }
  }

  getProgramTypes = (initialProgramType, key) => {
    let programTypes = [];
    const initialProgramTypePriority = this.getProgramTypePriority(initialProgramType);
    const {accountPageInfo} = this.props;

    for (let i = 0; i < this.props.subscriptions.length; i++) {
      let sub = this.props.subscriptions[i];
      if (sub.type === "kv-only" && key !== 'kitchen')
        continue;
      if (sub.type === 'bv-only' && key !== 'bathroom')
        continue;
      if (programTypes.indexOf(sub.type) === -1) {
        const priority = this.getProgramTypePriority(sub.type);
        if (accountPageInfo.isNew || priority >= initialProgramTypePriority) {
          programTypes.push(sub.type);
        }
      }
    }
    programTypes.sort();
    return programTypes;
  }

  updateProgramType = (key, value) => {
    let paymentTypes = this.getPaymentTypes(key, value);
    let paymentType = paymentTypes[0];
    let sub = this.props.subscriptions.find(s => s.id === paymentType.id);
    let period = sub.period;
    let price = "$" + sub.price.toFixed(2);
    switch (key.toLowerCase().trim()) {
      case "kitchen":
        store.dispatch(change('newEntity', 'enableKV', true));
        break;
      case "bathroom":
        store.dispatch(change('newEntity', 'enableBV', true));
        break;
      case "fireplace":
        store.dispatch(change('newEntity', 'enableFP', true));
        break;
      case "laundryroom":
        store.dispatch(change('newEntity', 'enableLR', true));
        break;
    }
    switch (period) {
      case 'annually':
        period = 'year';
        break;
      case 'monthly':
        period = 'month';
        break;
    }
    let msg = null;
    switch (sub.type) {
      case "free":
        msg = "You are subscribing to the Free Trial account. Are you sure you wish to proceed?";
        break;
      case "pay-per-lead":
        msg = `You are changing to the ${capitalizeFirstLetter(sub.type)} program. You will be charged ${price} per ${period} with this change. Are you sure you wish to proceed?`;
        break;
    }
    if (msg != null) {
      this.props.messageBoxEx_Show(true, "system", "Confirm Program Change", msg,
        [{
          text: 'Cancel',
          onClick: () => this.props.messageBoxEx_Show()
        },{
          text: 'Yes',
          color: "green",
          onClick: () => {
            this.props.messageBoxEx_Show(); //reset to default props (not visible by default)
            this.props.setSubscriptionsInfo({
              programTypeKey: key,
              [key + "ProgramType"]: value,
              [key + "PaymentType"]: "Select",
              [key + 'PaymentAmount']: sub.price
            })
              .then(() => {
                if (paymentTypes.length === 1) {
                  this.props.setSubscriptionsInfo({[key + "PaymentType"]: paymentType})
                    .then(() => {
                      if ((!this.props.paymentProfile || !this.props.paymentProfile.customerProfileId)
                        && !this.props.billingInformation.saveCC && sub.price > 0) {
                        this.props.toggleCreditCardPopup(true);
                        this.props.setBillingInformation && this.props.setBillingInformation({
                          onCCSave: () => {
                            this.props.setSubscriptionsInfo({
                              programTypeKey: key,
                              [key + "ProgramType"]: sub.type,
                              [key + "PaymentType"]: paymentType,
                              [key + 'PaymentAmount']: sub.price
                            })
                              .then(() => {
                                this.props.setSubscriptionId(key, sub);
                                this.showESignatureOverlay(key);
                              })
                          }
                        })
                      } else {
                        this.props.setSubscriptionIdFn(key, sub);
                        this.showESignatureOverlay(key);
                      }
                    })
                  if (key === "bathroom") {
                    this.setBathroomDefaults(sub);
                  }
                }
              })
          }
        }]
      );
    } else {
      this.props.setSubscriptionsInfo({
        programTypeKey: key,
        [key + "ProgramType"]: value,
        [key + "PaymentType"]: "Select",
        [key + 'PaymentAmount']: sub.price
      });
    }
  }

  getPaymentTypes = (key, programType = this.props.subscriptionsInfo[key + "ProgramType"], props = this.props, include = 0) => {
    let paymentTypes = [];
    for (let i = 0; i < props.subscriptions.length; i++) {
      let sub = props.subscriptions[i];
      if (sub.type === programType) {
        let text = sub.period;
        if (sub.adminOnly && ((!props.subscriptionsInfo[key + "PaymentType"] || props.subscriptionsInfo[key + "PaymentType"].id !== sub.id) && !this.props.AR.isSiteAdmin(true)) && (include == 0 || include != sub.id))
          continue;
        if (sub.adminOnly && sub.price === 0) {
          if (sub.period === "monthly") {
            text = "(SA Only) Free Monthly";
          } else {
            text = "(SA Only) Free Pre-Paid";
          }
        } else {
          if (sub.contractPeriod === "annually" && sub.period === "monthly") {
            text = "Annually, billed monthly";
          } else if (sub.contractPeriod === "annually" && sub.period === "annually") {
            text = "Annually, pre-paid";
          }
        }
        paymentTypes.push({id: sub.id, period: sub.period, contractPeriod: sub.contractPeriod, text});
      }
    }
    return paymentTypes;
  }

  updatePaymentType = (key, paymentType) => {
    //console.log(111, key, paymentType);
    let sub = this.props.subscriptions.find(s => s.id === paymentType.id);
    let price = "$" + sub.price.toFixed(2);
    let period = sub.period;
    let msg = `You are changing to the ${capitalizeFirstLetter(sub.type)} program. You will be charged ${price} per ${period} with this change. Are you sure you wish to proceed?`;
    this.props.messageBoxEx_Show(true, "system", "Confirm Program Change", msg,
      [{
        text: 'Cancel',
        onClick: () => this.props.messageBoxEx_Show()
      },
      {
        text: 'Yes',
        color: "green",
        onClick: () => {
          this.props.messageBoxEx_Show(); //reset to default props (not visible by default)
          this.props.setSubscriptionsInfo({
            programTypeKey: key,
            [key + "PaymentType"]: "Select",
            [key + 'PaymentAmount']: sub.price
          })
            .then(() => {
              if (key === "bathroom") {
                this.setBathroomDefaults(sub);
              }
              if ((!this.props.paymentProfile || !this.props.paymentProfile.customerProfileId) && !this.props.saveCC && sub.price > 0) {
                this.props.toggleCreditCardPopup(true);
                this.props.setBillingInformation && this.props.setBillingInformation({
                  onCCSave: () => {
                    this.props.setSubscriptionsInfo({
                      programTypeKey: key,
                      [key + "ProgramType"]: sub.type,
                      [key + "PaymentType"]: paymentType,
                      [key + 'PaymentAmount']: sub.price
                    })
                      .then(() => {
                        this.props.setSubscriptionId(key, sub);
                        this.showESignatureOverlay(key);
                      })
                  }
                })
              } else {
                this.props.setSubscriptionsInfo({
                  [key + "ProgramType"]: sub.type,
                  [key + "PaymentType"]: paymentType,
                  [key + 'PaymentAmount']: sub.price
                })
                  .then(() => {
                    this.props.setSubscriptionId(key, sub);
                    this.showESignatureOverlay(key);
                  })
              }
            });
        }
      }]
    );
  }

  setBathroomDefaults = (sub) => {
    switch (sub.type) { //preparing for the future of needing different selections based on subscription
      default:
        if (this.props.accountPageInfo.isNew) {
          store.dispatch(change('newEntity', 'enableSharing', true));
          store.dispatch(change('newEntity', 'wizardClients', true));
          store.dispatch(change('newEntity', 'wizardConsumers', true));
          store.dispatch(change('newEntity', 'leadCapture', true));
          store.dispatch(change('newEntity', 'twoFA', true));
          store.dispatch(change('newEntity', 'visualizerOnly', true));
          store.dispatch(change('newEntity', 'enableSharingKitchen', true));
          store.dispatch(change('newEntity', 'wizardClientsKitchen', true));
          store.dispatch(change('newEntity', 'wizardConsumersKitchen', true));
          store.dispatch(change('newEntity', 'leadCaptureKitchen', true));
          store.dispatch(change('newEntity', 'twoFAKitchen', true));
          store.dispatch(change('newEntity', 'visualizerOnlyKitchen', true));
        }
        break;
    }
  }

  showESignatureOverlay = (key) => {
    let paymentType = this.props.subscriptionsInfo[key + "PaymentType"];
    let sub = this.props.subscriptions.find(sub => sub.id === paymentType.id);
    if (sub && sub.adminOnly) {
      this.props.setSubscriptionsInfo({
        fabricatorNeedToSignAgreement: false
      })
    } else {
      var newAccountContent = document.getElementsByClassName('new-account-content');
      if(newAccountContent.length > 0)
        newAccountContent[0].classList.add('noscroll');
      
      this.props.setSubscriptionsInfo({
        showingESignFor: key,
        fabricatorNeedToSignAgreement: false
      });
      //this.props.showESignatureOverlayFn(true);
    }
  }

  getSubscriptionInfo = (sub) => {
    return (
      <div className="acc-block acc-block2__item--with-left-line">
        <div className="acc-block2">
          <div className="acc-block2__item">
            {sub.type ? (
              sub.type === 'free' ? <span className={"dropdown-underline-text"}>FREE TRIAL</span> : (
                <div className="acc-subscription">
                  <p className="acc-subscription__text">Only</p>
                  <p className="acc-subscription__amount">${sub.price.toFixed(2)}</p>
                  <p className="acc-subscription__text">
                    per {sub.period === 'monthly' ? 'month' : (sub.period === 'annually' ? 'year' : sub.period)}
                  </p>
                  {sub.contractPeriod === 'annually' && sub.period === 'annually' ? (
                    <p className="acc-subscription__text">(${(sub.price / 12).toFixed(2)} per month)</p>
                  ) : null}
                </div>
              )
            ) : (
              <span className={"dropdown-underline-text"}>Select a Program Type</span>
            )}
          </div>
        </div>
      </div>
    )
  };

}
